export default "__VITE_ASSET__58c3727f__"